<template>
  <div>
    <b-modal
      id="this-booking-is-for-modal"
      ref="this-booking-is-for-modal-ref"
      hide-footer
      title="This Booking Is For"
    >
      <b-card-body v-if="booking && booking.user_information">
        <p>Unless otherwise specified</p>
        <div
          v-for="(traveller, index) in booking.user_information.names_plus"
          :key="index"
        >
          <b-card-text class="consultant-booking-item">
            <div>{{ traveller.name }}</div>
            <span>
              <small v-if="traveller.dob">{{ traveller.dob }} &#8226; </small>
              <small v-if="traveller.passport">{{ traveller.passport }}</small>
              <br />
              <small
                class="text-danger"
                v-if="traveller.passportwarning === 'true'"
                >(Expires soon - please check)</small
              >
              <small v-if="traveller.canx">{{ traveller.canx }}</small>
            </span>
          </b-card-text>
        </div>
        <!-- alert -->
        <div class="alert-box" role="alert">
          <i class="material-icons vtd-pr-3 vtd-align-middle">&#xE002;</i>
          <span>
            Your first and last name must exactly match your passport.
            Middle names are not relevant at this stage.
            Please highlight any name discrepancies prior to making payment as they can be very costly to amend later.
          </span>
        </div>
      </b-card-body>

      <b-button class="mt-3" block @click="hide()"> Close </b-button>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: [],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      booking: (state) => state.booking.booking,
    }),
    ...mapGetters("booking", [
      "getBookingInfo",
      "getCountry",
      "getCityCodes",
      "getSupplierCodes",
      "getDestination",
    ]),
  },
  methods: {
    async showModal() {
      this.$refs["this-booking-is-for-modal-ref"].show();
    },
    hide() {
      this.$refs["this-booking-is-for-modal-ref"].hide();
    },
  },
};
</script>

<style>
@import "./styles.scss";
</style>
